import { render, staticRenderFns } from "./master_title.vue?vue&type=template&id=fbaa6ffa"
import script from "./master_title.vue?vue&type=script&lang=js"
export * from "./master_title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports